import { render } from "./LoanProgram.vue?vue&type=template&id=1d863b32&scoped=true"
import script from "./LoanProgram.vue?vue&type=script&lang=js"
export * from "./LoanProgram.vue?vue&type=script&lang=js"

import "./LoanProgram.vue?vue&type=style&index=0&id=1d863b32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d863b32"]])

export default __exports__